<template>
  <vs-popup class="popup-q-r-history" title="QR 참석자 명단 가져오기" :active.sync="showPopup">
    <div>
      <div class="flex items-center gap-2">
        <search-date label="스캔일시" v-model="date" :readonly="!!searchDate" @input="applySearch" />
        <div class="flex gap-4 items-center">
          <span class="title">{{ $t('회사명') }}</span>
          <field-selector class="w-full" v-model="field" :field-name="field.field_name" readonly />
        </div>
      </div>

      <vs-select class="mt-6" v-model="perPage" autocomplete style="width: 120px" @change="applySearch">
        <vs-select-item v-for="i in [10, 20, 50, 100]" :key="i" :text="`${i}개씩 보기`" :value="i" />
      </vs-select>

      <div class="mt-4">
        <vs-table class="w-full mb-4" stripe :sst="true" :max-items="perPage" :data="list" :multiple="true" v-model="selected" noDataText="데이터가 없습니다">
          <template slot="thead">
            <vs-th><span class="w-full text-center">No.</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('스캔일시') }}</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('스캐너 사용자') }}</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('회사명') }}</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('장소') }}</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('부서(업체)명') }}</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('소속') }}</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('직책') }}</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('이름') }}</span></vs-th>
            <vs-th><span class="w-full text-center">{{ $t('스캔 데이터') }}</span></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(tr, tr_i) in data" :key="`popup-q-r-history-${tr_i}`" :data="tr">
              <vs-td align="center">{{ total - ((loadedPage - 1) * perPage + tr_i) }}</vs-td>
              <vs-td align="center">{{ tr["스캔일자"] }}</vs-td>
              <vs-td align="center">{{ tr["스캐너 사용자"] }}</vs-td>
              <vs-td align="center">{{ tr["회사명"] }}</vs-td>
              <vs-td align="center">{{ tr["장소"] }}</vs-td>
              <vs-td align="center">{{ tr["업체명"] }}</vs-td>
              <vs-td align="center">{{ tr["소속"] }}</vs-td>
              <vs-td align="center">{{ tr["직책"] }}</vs-td>
              <vs-td align="center">{{ tr["이름"] }}</vs-td>
              <vs-td align="center">{{ tr["데이터"] }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage ? lastPage : 1" v-model="page" @change="onChangePage"></k-pagination>
        </div>
      </div>

      <div class="mt-8 flex justify-end gap-4">
        <vs-button color="secondary" type="border" @click="onClickClose">{{ $t('닫기') }}</vs-button>
        <vs-button color="secondary" @click="onClickUse">{{ $t('등록') }}</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import SearchNav from "@/components/nav/SearchNav.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";
import SearchStartEnd from "@/views/list/components/SearchStartEnd.vue";
import SearchDate from "@/views/list/components/SearchDate.vue";
import SearchSelect from "@/views/list/components/SearchSelect.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";
import SearchTimeStartEnd from "@/views/list/components/SearchTimeStartEnd.vue";
import KPagination from "@/components/kPagination/kPagination.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  name: "PopupQRHistory",
  components: {
    FieldSelector,
    KPagination,
    SearchTimeStartEnd,
    SearchKeyword,
    SearchSelect,
    SearchDate,
    SearchStartEnd,
    TimeSelectorRang,
    SearchNav,
  },
  props: {
    value: Boolean,
    projectId: Number,
    searchDate: String,
    searchField: Object,
  },
  computed: {
    showPopup: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    projId() {
      return this.projectId || this.$store.state.project.projectId;
    },
    optionFields() {
      return [
        { value: 0, text: "전체" },
        ...this.regions.map((item) => {
          return {
            text: item.name,
            value: item.id,
          };
        }),
      ];
    },
    memberInfo() {
      return this.$store.state.member.memberInfo;
    },
  },
  watch: {
    value(value) {
      if (value) {
        // 한국 시간으로 오늘 날짜
        this.date = new Date(this.searchDate).format("yyyy-MM-dd");
        this.field = this.searchField;
        this.page = 1;
        this.perPage = 10;
        this.keyword = "";
        this.loadHistory();
        this.loadRegionList();
      }
    },
  },
  data() {
    return {
      page: 1,
      loadedPage: 1,
      perPage: 20,
      lastPage: 1,
      total: 0,
      date: "",
      time: {
        startTime: "00:00:00",
        endTime: "23:59:59",
      },
      region: 0,
      zoneName: "",
      scanData: "",
      userComName: "",
      list: [],
      selected: [],
      regions: [],
      isMyScans: true,
      scannerName: "",
      field: {},
    };
  },

  methods: {
    formatDate(date, format = "yyyy-MM-dd") {
      if (!date) return "";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "";

      // 간단한 날짜 포맷팅 함수
      const pad = (num) => String(num).padStart(2, "0");

      return format
        .replace("yyyy", d.getFullYear())
        .replace("MM", pad(d.getMonth() + 1))
        .replace("dd", pad(d.getDate()))
        .replace("HH", pad(d.getHours()))
        .replace("mm", pad(d.getMinutes()))
        .replace("ss", pad(d.getSeconds()));
    },

    applySearch() {
      this.page = 1;
      this.loadHistory();
    },
    loadHistory() {
      const options = {
        params: {
          page: this.page,
          perPage: this.perPage,
          projectId: this.projId,
          type: "identity",
          boardId: 1040,
          //fieldId
          //postId
          //regionId
          //zoneId
          //scannerUerId
          //dateFrom
          //dateTo
          //scannerUserId
        },
      };

      // if (this.scannerName) {
      //   options.params.scannerName = this.scannerName;
      // }
      //
      const date = this.date;
      if (date) {
        const dateFrom = new Date(date);
        const startTime = this.time.startTime;
        const endTime = this.time.endTime;
        options.params.dateFrom = dateFrom.format(`yyyy-MM-dd ${startTime || '00:00:00'}`)
        if (endTime) {
          options.params.dateTo = dateFrom.format(`yyyy-MM-dd ${endTime}`);
        } else {
          options.params.dateTo = new Date(dateFrom.setDate(dateFrom.getDate() + 1)).format("yyyy-MM-dd 00:00:00");
        }
      }

      if (this.field && this.field.id) {
        options.params.regionId = this.field.id;
      }

      HttpRequest.get("/api/v1/project/qr/history/list", options)
        .then((res) => {
          console.log("QR 스캔 목록 조회:", res);
          this.list = this.convertList(res.data);
          this.total = res.total;
          this.lastPage = res.last_page;
          this.loadedPage = this.page;
        })
        .catch((err) => {
          console.error("QR 스캔 목록 조회 오류:", err);
        });
    },

    convertList(list) {
      return list.map((item) => {
        const scanner = item.scanner || {};
        const scannerInfo = [];
        if (scanner.department) {
          scannerInfo.push(scanner.department);
        }
        if (scanner.name) {
          scannerInfo.push(scanner.name);
        }
        if (scanner.rank) {
          scannerInfo.push(scanner.rank);
        }

        return {
          스캔일자: this.formatDate(item.created_at),
          // '스캔시간': this.formatDate(item.created_at, 'HH:mm:ss'),
          "스캐너 사용자": scannerInfo.length > 0 ? scannerInfo.join(" ") : "-",
          // '사업장명': item.region ? item.region.name : '-',
          회사명: item.field ? item.field.field_name : "-",
          장소: item.zone ? item.zone.name : "-",
          업체명: this.getCompany(item),
          소속: item.user ? item.user.department : "-",
          직책: item.user ? item.user.rank : "-",
          직종: item.meta ? item.meta.직종 : "-",
          이름: item.user ? item.user.name : "-",
          데이터: item.data || "-",
          raw: item,
        };
      });
    },

    loadRegionList() {
      const option = {
        params: {
          page: 1,
          perPage: 20,
          keyword: "", // 검색이 필요할 경우 사용,
        },
      };
      // keyword 를 사용하지 않을 경우 삭제
      if (option.params.keyword === "") {
        delete option.params.keyword;
      }

      // const api = '/api/v1/region';
      // HttpRequest.get(api, option)
      //   .then(response => {
      //     const data = response.data;
      //     this.regions = data;
      //   }).catch(err => {  })
    },

    getCompany(item) {
      let company = "";
      if (item.user && item.user.company) {
        company += item.user.company.com_name || "-";
      }
      return company;
    },

    onChangePage(page) {
      if (this.value) {
        this.loadHistory();
      }
    },

    onClickClose() {
      this.showPopup = false;
    },

    onClickUse() {
      this.$emit("select", this.selected);
      this.onClickClose();
    },
  },
};
</script>

<style scoped lang="scss">
.popup-q-r-history::v-deep {
  .vs-popup {
    width: 1500px !important;
    max-width: 90% !important;
  }

  .title {
    font-weight: 500;
    line-height: 38px;
    text-align: left;
    white-space: nowrap;

    @media (max-width: 1200px) {
      width: 80px !important;
    }
  }
}
</style>


